import type {CSSProperties} from 'react';
import {borderRadius, colors, fontSize, gradients, spacing} from './tokens';

/**
 * Site-wide icon tile: a 46×46 blue-gradient square with 4px padding.
 * The icon is capped at 24px and centred, so sources of different intrinsic
 * sizes all render as one consistent tile instead of stretching to the edges.
 */
export const ICON_TILE_SIZE = 46;

export const ICON_TILE_ICON_SIZE = 24;

export const iconTileSx = {
    width: ICON_TILE_SIZE,
    height: ICON_TILE_SIZE,
    minWidth: ICON_TILE_SIZE,
    p: spacing[4],
    borderRadius: borderRadius.md,
    background: gradients.darkSection,
    color: colors.text.inverse,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {fontSize: fontSize[24]}
} as const;

/**
 * Light variant: soft blue tile with the icon in brand blue, for cards that sit on a
 * tinted section and would read too heavily with the solid navy tile.
 */
export const iconTileLightSx = {
    ...iconTileSx,
    background: colors.background.tag,
    color: colors.primary.main
} as const;

/** Sizing only — the icon is scaled to fit the 24px box, never cropped or stretched. */
export const iconTileImageBaseStyle: CSSProperties = {
    width: ICON_TILE_ICON_SIZE,
    height: ICON_TILE_ICON_SIZE,
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
};

/** Flat monochrome source icons are knocked out to white on the gradient tile. */
export const iconTileImageStyle: CSSProperties = {
    ...iconTileImageBaseStyle,
    filter: 'brightness(0) invert(1)'
};
